import React, { Component } from 'react';
import FirstaboutSec from './FirstaboutSec';
import Offersection from "./Offersection";
import { allPics } from '../Firebase/TinqerPics';

require('./about.css');

class Aboutus extends Component {
    constructor(props) {
        super(props);
        this.phoneUs = this.phoneUs.bind(this);
        this.email = this.email.bind(this);
    }

    email() {
        location.href = "mailto:'tinqer@tinqer.io'"
    }
    phoneUs() {
        document.getElementById('phoneNumber').style.display = 'block';
    }


    render() {
        return (
            <div>
                <FirstaboutSec pics={allPics} />
                <Offersection pics={allPics} />
                <br />
                <section id="contactSection" className='sectionBreak'>
                    {/* <h2 style={{ textAlign: 'center', color: 'blue' }} >Contact Us</h2> */}
                    <div className="contactClass" style={{ paddingLeft: '30px', paddingRight: '30px' }}>
                        <div className="card contactCard">
                            <div className="card-block" id='contactCardBlock'>
                                <p style={{ color: 'white', fontSize: '23px' }}>Want a free quote or just want to say hello?</p>
                                <p style={{ color: 'white', fontSize: '20px' }}>Contact us:</p>
                                <div className="row">
                                    <div className='col-md-6'>
                                        <button className="btn" id='emailButton'
                                            onClick={() => this.email()}>Email</button>
                                    </div>
                                    <div className='col-md-6'>
                                        <button className="btn" id='phoneButton'
                                            onClick={() => this.phoneUs()}
                                        >Phone</button>
                                    </div>
                                </div>
                            </div>
                            {/*}
                            <h3 id='phoneNumber'
                                style={{ display: 'none', backgroundColor: 'white', marginTop: '30px', borderRadius: '10px' }}>
        </h3>*/}
                        </div>
                    </div>
                </section>
                <br />

            </div>
        );
    }
}

export default Aboutus;


// WEBPACK FOOTER //
// ./src/About/Aboutus.js